import { observer } from 'mobx-react';
import Loader from '../../../../../Loader';
import LoadingErrorView from './LoadingErrorView';
import ReadyView from './ReadyView';
import SubmittingErrorView from './SubmittingErrorView';
import { ModalFormState } from './Types';

interface Props {
  state: ModalFormState;
  submitting: () => void;
}

function Body({ state, submitting }: Props) {
  switch (state.kind) {
    case 'loading':
      return <Loader className="h-full" />;
    case 'loading-error':
      return <LoadingErrorView state={state} />;
    case 'ready':
      return <ReadyView state={state} submitting={submitting} />;
    case 'submitting':
      return <Loader className="h-full" />;
    case 'submitting-error':
      return <SubmittingErrorView state={state} />;
  }
}

export default observer(Body);
